export default __webpack_public_path__ + "static/media/manage.d84c7759.svg";